import { createSlice } from '@reduxjs/toolkit';
import { getAllAccountStats } from './accountStatsAction';

const allAccountStatsSlice = createSlice({
  name: 'allAccountStats',
  initialState: {
    loading: false,
    error: null,
    data: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllAccountStats.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAccountStats.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = {
        activeAccounts: payload.data.activeAccount,
      };
    });
    builder.addCase(getAllAccountStats.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default allAccountStatsSlice;
